import { AutocompleteOption } from '@types'

export const objectToOptions = (obj: Record<string, string>): AutocompleteOption[] => {
  if (!obj || typeof obj !== 'object') return []

  return Object.entries(obj).map(([id, label]) => ({ id, label, internalId: id }))
}
